/**
 * @file index.tsx
 *
 * @fileoverview Renders a paragraph that shows a text with multiple link buttons.
 */
import React from 'react';
import { TextWithMultipleButtonsParagraph } from '~/jobiqo/types/types';
import Spacing from '~/vcl/atoms/06-layout/07-spacing';
import { WYSIWYGText } from '~/vcl/atoms/13-text/02-WYSIWYG';
import Box from '~/vcl/atoms/07-box';
import { Main } from '~/vcl/atoms/06-layout/09-main';
import styles from './textWithMultipleButtons.module.scss';
import Link from '~/jobiqo/components/Link';
import LinkButton from '~/vcl/atoms/01-forms/01-button/02-link-button';
import NextLink from 'next/link';
import { getFormattedPageLink } from '~/jobiqo/utils/routes';

interface TextWithMultipleButtonsProps {
  row: TextWithMultipleButtonsParagraph;
  maxContainerSize?: 'small' | 'medium' | 'large' | 'xLarge';
}

export const TextWithMultipleButtons = ({
  row,
  maxContainerSize,
}: TextWithMultipleButtonsProps) => {
  return (
    <Box
      className={'jd-lp-text-multiple-buttons-box'}
      boxShadow="none"
      borderRadius="0px"
      margin={0}
      padding={0}
      backgroundColorOverride={
        row.background
          ? `var(--color-${row.background})`
          : `var(--color-primary)`
      }
    >
      <Main {...(maxContainerSize ? { size: maxContainerSize } : null)}>
        <Spacing
          paddingTop={row.spacing ?? 6}
          paddingBottom={row.spacing ?? 6}
          margin={0}
        >
          {row.text && <WYSIWYGText format="full_html" content={row.text} />}
          <Spacing />
          {row.links && (
            <div
              className={`${styles.buttonContainer} jd-lp-text-multiple-buttons-button-container`}
            >
              {row.links.map((item, key) => {
                return (
                  item?.url && (
                    <Link asChild key={key} prefetch={false}>
                      <LinkButton
                        linkElement={NextLink}
                        className={`${styles.buttonPill} jd-lp-text-multiple-buttons-button`}
                        {...getFormattedPageLink(item?.url)}
                        buttonStyle={row.color as any}
                      >
                        {item.text}
                      </LinkButton>
                    </Link>
                  )
                );
              })}
            </div>
          )}
        </Spacing>
      </Main>
    </Box>
  );
};

export default TextWithMultipleButtons;
